import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft, ShoppingBag } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CartContent } from './CartContent';

export const Cart: React.FC = () => {
  const { t } = useTranslation();

  const emptyCartContent = (
    <div className="text-center py-12">
      <ShoppingBag className="w-16 h-16 mx-auto mb-4 text-muted-foreground" />
      <h2 className="text-2xl font-semibold mb-2">{t('cart.empty')}</h2>
      <p className="text-muted-foreground">{t('cart.addPhotosToStart')}</p>
    </div>
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-6">
        <Button variant="ghost" size="sm" asChild>
          <Link to="/">
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t('common.backToHome')}
          </Link>
        </Button>
      </div>
      
      <div className="max-w-6xl mx-auto">
        <CartContent 
          showHeader={true}
          showClearButton={true}
          emptyCartContent={emptyCartContent}
        />
      </div>
    </div>
  );
};